import { iaRa } from 'lib/helpers/utility';

const MEDICATION_TIMESTAMP_FIELDS = ['end_date', 'start_date', 'updated_at', 'created_at'];

const getMedicationTimestamp = (medication = {}) => {
  for (const field of MEDICATION_TIMESTAMP_FIELDS) {
    const fieldValue = medication?.[field];

    if (!fieldValue) {
      continue;
    }

    const timestamp = new Date(fieldValue).getTime();

    if (!Number.isNaN(timestamp)) {
      return timestamp;
    }
  }

  return null;
};

const pickLatestMedication = (medications = []) => {
  const medicationItems = iaRa(medications);

  if (!medicationItems.length) {
    return null;
  }

  return medicationItems.reduce((latestMedication, currentMedication) => {
    if (!latestMedication) {
      return currentMedication;
    }

    const latestTimestamp = getMedicationTimestamp(latestMedication);
    const currentTimestamp = getMedicationTimestamp(currentMedication);

    if (currentTimestamp == null && latestTimestamp == null) {
      return latestMedication;
    }

    if (currentTimestamp == null) {
      return latestMedication;
    }

    if (latestTimestamp == null) {
      return currentMedication;
    }

    return currentTimestamp > latestTimestamp ? currentMedication : latestMedication;
  }, null);
};

export const getGroupedMedicationData = (params) => {
  if (!params?.node?.group) {
    return params?.data ?? null;
  }

  const groupedMedications = iaRa(params?.node?.allLeafChildren)
    .map((node) => node?.data)
    .filter(Boolean);

  return pickLatestMedication(groupedMedications);
};

export const getMedicationDoseText = (medication, { spacedUnit = false } = {}) => {
  if (!medication) {
    return null;
  }

  const unitText = medication?.unit ? `${spacedUnit ? ' ' : ''}(${medication.unit})` : '';
  const doseText = `${medication?.strength ?? ''}${unitText}`;

  return doseText || null;
};
